import common from "./common";
import auth from "./auth";
import welcome from "./welcome";
import events from "./events";
import eventsAdd from "./eventsAdd";
import preparationCalendar from "./preparationCalendar";
import event from "./event";
import services from "./services";
import profile from "./profile";
import support from "./support";
import feedback from "./feedback";
import notification from "./notification";
import manager from "./manager";
import buildingDocs from "./buildingDocs";
import participantTermsDocs from "./participantTermsDocs";
import helpForm from "./helpForm";

export default {
  common,
  auth,
  buildingDocs,
  participantTermsDocs,
  welcome,
  events,
  eventsAdd,
  preparationCalendar,
  event,
  services,
  profile,
  support,
  feedback,
  notification,
  manager,
  helpForm
};
